module.exports = __webpack_public_path__ + "img/doc-file.d92de826.svg";